import { PageMap } from '@wix/wixstores-client-core';
import { BaseActions } from './baseActions';

export class SideCartActions extends BaseActions {
  public async showSideCart(options: {
    allowShowingSideCartOnMobile: boolean;
  }) {
    const dontShowSideCartOnMobile =
      this.siteStore.storage.memory.getItem('dontShowSideCartOnMobile') ===
      'true';

    const blockOpenSideCart =
      this.siteStore.isMobile() &&
      dontShowSideCartOnMobile &&
      !options.allowShowingSideCartOnMobile;

    if (blockOpenSideCart) {
      throw Error("Migrated Side Cart can't be open in mobile");
    }

    const sideCartLightbox = await this.getSideCartLightbox();
    if (sideCartLightbox) {
      this.openSideCart(sideCartLightbox.id!);
    } else {
      return this.navigateToCart(this.origin);
    }
  }

  private async navigateToCart(origin: string): Promise<void> {
    return this.siteStore.navigate(
      {
        sectionId: PageMap.CART,
        queryParams: { origin },
      },
      true,
    );
  }

  private openSideCart(id: string): void {
    if (this.siteStore.siteApis.currentPage?.type === 'lightbox') {
      this.siteStore.windowApis.lightbox.close();
    }
    void this.siteStore.windowApis.openLightboxById(id, {});
  }

  private async getSideCartLightbox() {
    const siteStructure = await this.siteStore.wixCodeApi.site.getSiteStructure(
      { includePageId: true },
    );
    return siteStructure.lightboxes?.find(
      (lightbox) => lightbox.tpaPageId === PageMap.SIDE_CART,
    );
  }

  public async getSideCartName() {
    const sideCart = await this.getSideCartLightbox();
    return sideCart?.name;
  }

  public async hasSideCart(): Promise<boolean> {
    const sideCartLightbox = await this.getSideCartLightbox();
    return !!sideCartLightbox;
  }
}
